var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      staticStyle: { padding: "15px 0 10px 0" },
      attrs: { "label-width": "80px", inline: true }
    },
    [
      _c(
        "transition",
        { attrs: { duration: 350 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { label: "工单状态" }
            },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.searchData.orderStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "orderStatus", $$v)
                    },
                    expression: "searchData.orderStatus"
                  }
                },
                _vm._l(_vm.orderStatusList, function(st) {
                  return _c(
                    "el-checkbox",
                    { key: st.value, attrs: { label: st.value } },
                    [_vm._v(_vm._s(st.name))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 300 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "创建于" }
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "240px" },
                attrs: {
                  "picker-options": _vm.datePickerOptions,
                  "start-placeholder": "开始",
                  "end-placeholder": "结束",
                  type: "daterange",
                  "value-format": "yyyy-MM-dd"
                },
                on: { change: _vm.ticketCreateTimeChange },
                model: {
                  value: _vm.ticketCreateTimeRange,
                  callback: function($$v) {
                    _vm.ticketCreateTimeRange = $$v
                  },
                  expression: "ticketCreateTimeRange"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 450 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "更新于" }
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "240px" },
                attrs: {
                  "picker-options": _vm.datePickerOptions,
                  "start-placeholder": "开始",
                  "end-placeholder": "结束",
                  type: "daterange",
                  "value-format": "yyyy-MM-dd"
                },
                on: { change: _vm.ticketUpdateTimeChange },
                model: {
                  value: _vm.ticketUpdateTimeRange,
                  callback: function($$v) {
                    _vm.ticketUpdateTimeRange = $$v
                  },
                  expression: "ticketUpdateTimeRange"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 250 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "创建人" }
            },
            [
              _c("DealUserSearch", {
                ref: "creatorUser_3",
                attrs: { css: "width: 240px;" },
                on: { change: _vm.onCreatorIdChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 200 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "处理人" }
            },
            [
              _c("DealUserSearch", {
                ref: "assignUser_3",
                attrs: { css: "width: 240px;" },
                on: { change: _vm.onDealUserIdChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "工单标题" } },
        [
          _c("el-input", {
            staticStyle: { width: "240px" },
            attrs: { placeholder: "工单标题/内容/编号", clearable: "" },
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.doSearch.apply(null, arguments)
              }
            },
            model: {
              value: _vm.searchData.orderTitle,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "orderTitle", $$v)
              },
              expression: "searchData.orderTitle"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.advancedSearch,
              expression: "advancedSearch"
            }
          ],
          attrs: { label: "项目" }
        },
        [
          _c("TicketProjectSelect", {
            staticStyle: { width: "240px" },
            model: {
              value: _vm.searchData.projectIds,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "projectIds", $$v)
              },
              expression: "searchData.projectIds"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 200 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "抄送人" }
            },
            [
              _c("DealUserSearch", {
                ref: "ticketCc_71",
                attrs: { css: "width: 240px;" },
                on: { change: _vm.onTicketCcChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 150 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "工单类型" }
            },
            [
              _c("TicketTypeCascader", {
                attrs: { css: "width: 240px;" },
                model: {
                  value: _vm.searchData.orderType,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "orderType", $$v)
                  },
                  expression: "searchData.orderType"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.advancedSearch,
              expression: "advancedSearch"
            }
          ],
          attrs: { label: "解决人", title: "最后一个将工单标记为已解决的人" }
        },
        [
          _c("DealUserSearch", {
            ref: "solveUser_3",
            attrs: { css: "width: 240px;" },
            on: { change: _vm.updateSolveUserId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 100 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "优先级" }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "240px" },
                  attrs: { clearable: "", placeholder: "请选择优先级" },
                  model: {
                    value: _vm.searchData.orderPriority,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "orderPriority", $$v)
                    },
                    expression: "searchData.orderPriority"
                  }
                },
                _vm._l(_vm.orderPriorityList, function(ll) {
                  return _c("el-option", {
                    key: ll.id,
                    attrs: { label: ll.name, value: ll.id }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 50 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "标签" }
            },
            [
              _c("el-input", {
                staticStyle: { width: "240px" },
                attrs: { placeholder: "输入标签", clearable: "" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.doSearch.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.searchData.tag,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "tag", $$v)
                  },
                  expression: "searchData.tag"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { duration: 400 } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.advancedSearch,
                  expression: "advancedSearch"
                }
              ],
              attrs: { label: "商家" }
            },
            [
              _c("MerchantSearch", {
                staticStyle: { width: "240px" },
                model: {
                  value: _vm.searchData.merchantId,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "merchantId", $$v)
                  },
                  expression: "searchData.merchantId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticStyle: { "margin-left": "80px", width: "240px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "70px" },
              attrs: { title: "查询符合条件的工单[98]", type: "primary" },
              on: { click: _vm.doSearch }
            },
            [_vm._v("搜索")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "70px" },
              attrs: { title: "清空搜索条件" },
              on: { click: _vm.resetSearch }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "TicketNewBtn",
              staticStyle: { width: "70px" },
              attrs: { title: "提交新工单" },
              on: { click: _vm.onNewTicketBtnClick }
            },
            [_vm._v("新增")]
          ),
          _vm._v(" "),
          _c("TicketWidgetGroup", {
            attrs: { group: "AfterTicketSearchButton" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticStyle: { "margin-left": "80px", width: "240px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "100px", "margin-right": "30px" },
              on: { click: _vm.clickAdvancedSearch }
            },
            [_vm._v(_vm._s(_vm.advancedSearch ? "简单搜索" : "高级搜索"))]
          ),
          _vm._v(" "),
          _c("TicketExportButton", { on: { export: _vm.doExport } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticStyle: { "margin-left": "80px", width: "240px" } },
        [
          _c("TicketWidgetGroup", { attrs: { group: "AfterTicketSearchForm" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1500941b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1500941b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketSearchForm.vue
// module id = 850
// module chunks = 75